"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.pushErrorMessage = pushErrorMessage;
exports["default"] = pushLogMessage;
exports.pushTravelAndCareLogMessage = pushTravelAndCareLogMessage;
exports.pushGenericLogMessage = pushGenericLogMessage;
exports.pushVideoUsageLogMessage = pushVideoUsageLogMessage;
exports.pushAudioUsageLogMessage = pushAudioUsageLogMessage;
exports.loggingAvailable = loggingAvailable;

var _promise = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/promise"));

var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs2/regenerator"));

var _typeof2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/typeof"));

var _stringify = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/json/stringify"));

var _assign = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/assign"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/asyncToGenerator"));

var _DataStore = _interopRequireWildcard(require("../../Stores/DataStore2"));

var _RegisterInstance = _interopRequireDefault(require("../RegisterInstance"));

var _HttpRequest = require("../../../utils/HttpRequest");

var _ArrayHelper = require("../../../helpers/ArrayHelper");

var _BuildConstants = require("../../../utils/BuildConstants");

var _config = _interopRequireDefault(require("../../../../targets/cord_sanofi/config.js"));

var _StringHelper = _interopRequireDefault(require("../../../helpers/StringHelper"));

var _LogStore = _interopRequireDefault(require("../../Stores/LogStore"));

var _ResumeSuspendListeners = require("../../../helpers/ResumeSuspendListeners");

var _TimeoutHelper = require("../../../helpers/TimeoutHelper");

var MIN_LOGS_LENGTH_TO_SEND = 10;
var ON_FAIL_RETRY_WAIT_TIME = 10 * 1000; // 10 seconds

var MAX_WAITING_TIME_TO_SEND_LOGS = 30 * 1000; // 30 seconds

var DEFAULT_LOG_SEND_TIMEOUT = 60000;
var MAX_SINGLE_LOG_SIZE = 62000; // 62k

var MAX_LOG_PACKET_SIZE = 500000; // 500k

var lastLogNumber = null;
var nextLogNumberArray = [];
var sendTimer = null;
var sendLogsAllowed = true;

var sanitizePath = function sanitizePath(id, path) {
  id = String(id);

  if (!path) {
    return '!' + id;
  }

  path = path.toString();

  if (path.length === 0) {
    return '!' + id;
  }

  while (path.substring(0, 1) === '!' && path.length > 1) {
    path = path.substring(1);
  }

  var elements = path.split('!');
  var lastElement = elements.pop();

  while (lastElement === '') {
    lastElement = elements.pop();
  }

  if (lastElement) {
    elements.push(lastElement);
  }

  if (lastElement.toString() !== id) {
    elements.push(id);
  }

  return '!' + elements.join('!');
};

var isSending = false;
var sendingAllowedTimer = null;
(0, _ResumeSuspendListeners.addOnSuspendListener)(function () {
  console.log('stop sending log messages while app is suspended (starting in 1 sec from now');
  sendingAllowedTimer = setTimeout(function () {
    sendLogsAllowed = false;
    clearTimeout(sendTimer);
  }, 1000);
});
(0, _ResumeSuspendListeners.addOnResumeListener)(function () {
  clearTimeout(sendingAllowedTimer);
  console.log('allow sending log messages after app resume');
  sendLogsAllowed = true;
  sendLogsToServerNow();
});

function fetchLogs(_x) {
  return _fetchLogs.apply(this, arguments);
}

function _fetchLogs() {
  _fetchLogs = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(logs) {
    var logsToSend, logsToDelete, logsToSendLength, i, logEntry, logLength, logsNew;
    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            logsToSend = [];
            logsToDelete = [];
            logsToSendLength = 2;
            i = 0;

          case 4:
            if (!((0, _stringify["default"])(logsToSend).length < MAX_LOG_PACKET_SIZE && logs.length > i)) {
              _context.next = 34;
              break;
            }

            logEntry = logs[i];
            logLength = (0, _stringify["default"])(logEntry).length;

            if (!(logLength > MAX_SINGLE_LOG_SIZE)) {
              _context.next = 27;
              break;
            }

            console.log('INFO', 'KESI2.LogService.fetchLogs single log too long:', logLength, logEntry);

            if (!((0, _typeof2["default"])(logEntry) === 'object' && logEntry.message && typeof logEntry.message === 'string')) {
              _context.next = 23;
              break;
            }

            _context.prev = 10;
            // if the message is JSON we can't shorten it. Best check if it's JSON is simply to parse it
            JSON.parse(logEntry.message);
            console.log('INFO', 'KESI2.LogService.fetchLogs mustDelete', logLength, logEntry);
            logsToDelete.push(logEntry);
            i += 1;
            return _context.abrupt("continue", 4);

          case 18:
            _context.prev = 18;
            _context.t0 = _context["catch"](10);

            // JSON.parse throw an error so the message is an ordinary string
            if (logEntry.message.length > MAX_SINGLE_LOG_SIZE) {
              logEntry.message = logEntry.message.substring(0, MAX_SINGLE_LOG_SIZE - 200);
              logLength = (0, _stringify["default"])(logEntry).length;
            }

          case 21:
            _context.next = 27;
            break;

          case 23:
            console.log('INFO', 'KESI2.LogService.fetchLogs mustDelete', logLength, logEntry);
            logsToDelete.push(logEntry);
            i += 1;
            return _context.abrupt("continue", 4);

          case 27:
            if (!(logsToSendLength + logLength + 1 > MAX_LOG_PACKET_SIZE)) {
              _context.next = 29;
              break;
            }

            return _context.abrupt("break", 34);

          case 29:
            // push entry
            logsToSend.push(logEntry);
            logsToSendLength += logLength + 1; // take next if possible

            i += 1;
            _context.next = 4;
            break;

          case 34:
            logsNew = _LogStore["default"].getData();
            logsToDelete.forEach(function (log) {
              (0, _ArrayHelper.removeElementWithFindFunction)(logsNew, function (e) {
                return e.deviceUTCTime === log.deviceUTCTime;
              });
            });
            _context.next = 38;
            return _LogStore["default"].setData(logsNew);

          case 38:
            return _context.abrupt("return", logsToSend);

          case 39:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[10, 18]]);
  }));
  return _fetchLogs.apply(this, arguments);
}

function sendLogsToServerNow() {
  return _sendLogsToServerNow.apply(this, arguments);
}

function _sendLogsToServerNow() {
  _sendLogsToServerNow = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2() {
    var logs, logsToSend, url, token, logsNew;
    return _regenerator["default"].wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            if (sendLogsAllowed) {
              _context2.next = 2;
              break;
            }

            return _context2.abrupt("return");

          case 2:
            if (isSending) {
              _context2.next = 43;
              break;
            }

            isSending = true;
            _context2.prev = 4;
            logs = _LogStore["default"].getData();
            console.log('INFO', 'KESI2.LogService.sendLogsToServerNow logs ready for send:', logs.length);

            if (!(logs && logs.length)) {
              _context2.next = 30;
              break;
            }

            _context2.next = 10;
            return fetchLogs(logs);

          case 10:
            logsToSend = _context2.sent;
            console.log('INFO', 'KESI2.LogService.sendLogsToServerNow logs to send in the next request', logsToSend.length, (0, _stringify["default"])({
              logs: logsToSend
            }).length);

            if (_config["default"].logSendUrl) {
              _context2.next = 15;
              break;
            }

            console.warn('can\'t send logs to server because logSendUrl is not set in target config');
            return _context2.abrupt("return");

          case 15:
            url = _BuildConstants.LEDGER_HOST + '/' + _config["default"].logSendUrl;

            if (!_config["default"].backendUseBearerAuth) {
              _context2.next = 24;
              break;
            }

            _context2.next = 19;
            return _RegisterInstance["default"].getAccessToken('logAggregate:write');

          case 19:
            token = _context2.sent;
            _context2.next = 22;
            return (0, _HttpRequest.httpPostJsonEncoded)(url, {
              logs: logsToSend
            }, null, DEFAULT_LOG_SEND_TIMEOUT, 2, 'Bearer ' + token, null, null, false);

          case 22:
            _context2.next = 26;
            break;

          case 24:
            _context2.next = 26;
            return (0, _HttpRequest.httpPostJsonEncoded)(url, {
              logs: logsToSend
            }, null, null, null, _HttpRequest.DEFAULT_USER_AUTH, null, null, false);

          case 26:
            // remove sent logs from DataStore
            // retrieve again in case any new log messages were added during sending
            logsNew = _LogStore["default"].getData();
            logsToSend.forEach(function (log) {
              (0, _ArrayHelper.removeElementWithFindFunction)(logsNew, function (e) {
                return e.deviceUTCTime === log.deviceUTCTime;
              });
            });
            _context2.next = 30;
            return _LogStore["default"].setData(logsNew);

          case 30:
            isSending = false;
            _context2.next = 43;
            break;

          case 33:
            _context2.prev = 33;
            _context2.t0 = _context2["catch"](4);
            console.error('ERROR', 'KESI2.LogService.sendLogsToServerNow', "error sending logs to server, retrying in ".concat(ON_FAIL_RETRY_WAIT_TIME, "ms."), _context2.t0);

            if (!(_context2.t0.message && (_context2.t0.message === 'ERROR_HTTP_STATUS_403' || _context2.t0.message === 'ERROR_HTTP_STATUS_401'))) {
              _context2.next = 39;
              break;
            }

            _context2.next = 39;
            return _RegisterInstance["default"].forceRenewAccessToken();

          case 39:
            isSending = false;
            _context2.next = 42;
            return (0, _TimeoutHelper.timeout)(ON_FAIL_RETRY_WAIT_TIME);

          case 42:
            sendLogsToServerDeferred();

          case 43:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[4, 33]]);
  }));
  return _sendLogsToServerNow.apply(this, arguments);
}

function sendLogsToServerDeferred() {
  clearTimeout(sendTimer);

  var logs = _LogStore["default"].getData();

  if (!isSending && logs.length > MIN_LOGS_LENGTH_TO_SEND) {
    sendLogsToServerNow();
  } else {
    sendTimer = setTimeout(function () {
      if (!isSending) {
        sendLogsToServerNow();
      } else {
        sendLogsToServerDeferred();
      }
    }, MAX_WAITING_TIME_TO_SEND_LOGS);
  }
}

function getNextLogNumber() {
  return _getNextLogNumber.apply(this, arguments);
}

function _getNextLogNumber() {
  _getNextLogNumber = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3() {
    return _regenerator["default"].wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            if (!(lastLogNumber === null)) {
              _context3.next = 2;
              break;
            }

            return _context3.abrupt("return", new _promise["default"](function (resolve) {
              nextLogNumberArray.push(resolve);
            }));

          case 2:
            lastLogNumber += 1;

            _DataStore["default"].setSingleData(_DataStore.DATA_STORE_PATHS.LOG_MESSAGES_COUNT, lastLogNumber);

            return _context3.abrupt("return", lastLogNumber);

          case 5:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return _getNextLogNumber.apply(this, arguments);
}

function addMessage(_x2) {
  return _addMessage.apply(this, arguments);
}

function _addMessage() {
  _addMessage = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee4(message) {
    var logs;
    return _regenerator["default"].wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            if (!(message === null)) {
              _context4.next = 3;
              break;
            }

            console.error('null log message discarded');
            return _context4.abrupt("return");

          case 3:
            if (!((0, _typeof2["default"])(message) !== 'object')) {
              _context4.next = 6;
              break;
            }

            console.error('non object log message discarded', message);
            return _context4.abrupt("return");

          case 6:
            if (_LogStore["default"].storeReady) {
              _context4.next = 11;
              break;
            }

            _context4.next = 9;
            return (0, _TimeoutHelper.timeout)(50);

          case 9:
            _context4.next = 6;
            break;

          case 11:
            logs = _LogStore["default"].getData();

            if (!logs) {
              logs = [];
            }

            if (!message.hasOwnProperty('deviceUTCTime')) {
              message.deviceUTCTime = new Date().getTime();
            }

            if (message.hasOwnProperty('applicationInstanceId')) {
              _context4.next = 18;
              break;
            }

            _context4.next = 17;
            return _RegisterInstance["default"].getApplicationInstanceId();

          case 17:
            message.applicationInstanceId = _context4.sent;

          case 18:
            if (message.hasOwnProperty('logNumber')) {
              _context4.next = 22;
              break;
            }

            _context4.next = 21;
            return getNextLogNumber();

          case 21:
            message.logNumber = _context4.sent;

          case 22:
            if (message.hasOwnProperty('message')) {
              if (typeof message.message !== 'string') {
                try {
                  message.message = (0, _stringify["default"])(message.message);
                } catch (error) {
                  console.error('error ');
                  message.message = '[message was null or not a string - discarded in client]';
                }
              }
            }

            console.log('add log message', message);
            logs.push(message);
            _context4.next = 27;
            return _LogStore["default"].setData(logs);

          case 27:
            sendLogsToServerDeferred();

          case 28:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));
  return _addMessage.apply(this, arguments);
}

function pushErrorMessage(messageDisplayedToUser, error) {
  var message = {
    type: 'error',
    messageToUser: _StringHelper["default"].stringifyAnything(messageDisplayedToUser),
    error: _StringHelper["default"].stringifyAnything(error)
  };
  console.log('sending error message', message);
  addMessage(message);
}
/**
 *
 * @param id     - the content element's id
 * @param path   - the path to the content element
 * @param extraInfo
 *
 * build a message enhanced with the applicationInstanceId, and localTimestamp
 * store it async in a local persistent queue
 */


function pushLogMessage(_x3, _x4) {
  return _pushLogMessage.apply(this, arguments);
}

function _pushLogMessage() {
  _pushLogMessage = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee5(id, path) {
    var extraInfo,
        message,
        _args5 = arguments;
    return _regenerator["default"].wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            extraInfo = _args5.length > 2 && _args5[2] !== undefined ? _args5[2] : {};
            message = (0, _assign["default"])({}, extraInfo, {
              id: id,
              type: 'content',
              path: sanitizePath(id, path)
            });
            _context5.next = 4;
            return addMessage(message);

          case 4:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));
  return _pushLogMessage.apply(this, arguments);
}

function pushTravelAndCareLogMessage(action) {
  var extraInfo = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (!_config["default"].isSafetureApp) {
    return;
  }

  var message = (0, _assign["default"])({}, extraInfo, {
    action: action
  });
  addMessage(message);
}

function pushGenericLogMessage(messageJson) {
  addMessage(messageJson);
}

function pushVideoUsageLogMessage(_x5, _x6, _x7, _x8) {
  return _pushVideoUsageLogMessage.apply(this, arguments);
}

function _pushVideoUsageLogMessage() {
  _pushVideoUsageLogMessage = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee6(id, path, sequences, chapters) {
    var message;
    return _regenerator["default"].wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            message = {
              id: id,
              type: 'video',
              sequences: sequences,
              chapters: chapters,
              path: sanitizePath(id, path)
            };
            _context6.next = 3;
            return addMessage(message);

          case 3:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6);
  }));
  return _pushVideoUsageLogMessage.apply(this, arguments);
}

function pushAudioUsageLogMessage(_x9, _x10, _x11, _x12) {
  return _pushAudioUsageLogMessage.apply(this, arguments);
}

function _pushAudioUsageLogMessage() {
  _pushAudioUsageLogMessage = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee7(id, path, sequences, chapters) {
    var message;
    return _regenerator["default"].wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            message = {
              id: id,
              type: 'audio',
              sequences: sequences,
              path: sanitizePath(id, path)
            };
            console.log('audiolog', message);
            _context7.next = 4;
            return addMessage(message);

          case 4:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee7);
  }));
  return _pushAudioUsageLogMessage.apply(this, arguments);
}

function loggingAvailable() {
  return _loggingAvailable.apply(this, arguments);
}

function _loggingAvailable() {
  _loggingAvailable = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee8() {
    return _regenerator["default"].wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            _context8.next = 2;
            return _DataStore["default"].getElementByPath(_DataStore.DATA_STORE_PATHS.LOG_MESSAGES_COUNT);

          case 2:
            _context8.t0 = _context8.sent;

            if (_context8.t0) {
              _context8.next = 5;
              break;
            }

            _context8.t0 = 0;

          case 5:
            lastLogNumber = _context8.t0;
            nextLogNumberArray.forEach(function (callback, index) {
              var logNumber = lastLogNumber + index + 1;
              callback(logNumber);
            });
            lastLogNumber += nextLogNumberArray.length;

            _DataStore["default"].setSingleData(_DataStore.DATA_STORE_PATHS.LOG_MESSAGES_COUNT, lastLogNumber);

          case 9:
          case "end":
            return _context8.stop();
        }
      }
    }, _callee8);
  }));
  return _loggingAvailable.apply(this, arguments);
}